import { navigate } from "../router.js";

export function NotFound({ path }: { path: string }) {
  return (
    <section className="page-narrow">
      <h1>On On! But not here.</h1>
      <p className="muted">Nothing at <code>{path}</code>. Try the calendar.</p>
      <a
        className="btn btn-primary"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        }}
      >
        Back home
      </a>
    </section>
  );
}
